import type { IconData } from '@stacksjs/iconify-core'

export const wifiSignal2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M503.785 124.254a432.02 432.02 0 0 0-495.57 0L8 124.4v27.438L86.881 264.5L237.778 480h36.444l150.9-215.5L504 151.842V124.4Zm-313.961 231.47l75.96-117.392a240 240 0 0 1 43.276 5.686l-95.22 146Zm-19.809-28.291l-38.265-54.649a238.2 238.2 0 0 1 94.9-32.873Zm63.606 90.838l107.373-164.639a239.3 239.3 0 0 1 39.256 19.152L256 450.232Zm165.018-171.748a272.03 272.03 0 0 0-285.278 0l-73.5-104.976a400.04 400.04 0 0 1 432.288 0Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default wifiSignal2
